// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'

const EvaluateQuestion = styled.i`
  margin-left: 2px;
  color: ${Colors.black};
`

const EvaluateHelpBaloon = styled.span`
  position: static;
  text-align: left;
  color: ${Colors.black};
  font-weight: normal;
  line-height: 1.4;
  font-size: 12px;
  display: block;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  background: ${Colors.white};
  border-radius: 3px;
  z-index: 9;
  width: 250px;

  &::before {
    position: absolute;
    top: -7px;
    left: 28%;
    margin-left: -8px;
    height: 15px;
    width: 15px;
    background: ${Colors.white};
    transform: rotate(45deg);
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    content: ' ';
  }
`

const EvalueateHelpBaloonInner = styled.span`
  display: block;
  padding: 10px;
  background: ${Colors.white};
  border-radius: 3px;
  transform: rotate(0deg);
`

const OptionIcon = styled.i`
  margin-right: 5px;
  font-size: 15px;
  color: ${Colors.blue};

  &[data-icon='flash'] {
    padding: 0 4px;
  }

  &[data-icon='discount'] {
    vertical-align: -9%;
  }

  &[data-icon='host'] {
    vertical-align: -9%;
  }
`

function getIconClassName(iconType) {
  switch (iconType) {
    case 'flash':
      return 'fa-flash'
    case 'discount':
      return 'icon-spm-discount'
    case 'host':
      return 'icon-spm-top_host'
    default:
      return ''
  }
}

export default ({ item, onChange, checked }) => (
  <div>
    <input
      className="search-check-box"
      id={item.id}
      type="checkbox"
      onChange={onChange}
      checked={checked}
    />
    <label className="search-check-box-label" htmlFor={item.id}>
      {item.beforeIcon && (
        <OptionIcon
          className={`fa ${getIconClassName(item.beforeIcon)}`}
          data-icon={item.beforeIcon}
        />
      )}
      {item.label}
      {item.afterIcon && (
        <span className="evaluate-help-tool">
          <EvaluateQuestion className={`fa fa-${item.afterIcon}`} />
          <span className="evaluate-help-tool-tip">
            <EvaluateHelpBaloon>
              <EvalueateHelpBaloonInner>
                {item.hoverMessage}
              </EvalueateHelpBaloonInner>
            </EvaluateHelpBaloon>
          </span>
        </span>
      )}
    </label>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/molecules/SearchCheckboxWrap.jsx